import { CartProductSchema } from '../../types';
import { State } from '../types';
import { getIdsOfLinkedProductsAndApps } from './get-linked-products-and-apps';

export const getTimestampFromLinkedProductsOrApps = ({
  parentEntitlementId,
  products,
  linkedEntitlements,
}: {
  parentEntitlementId: CartProductSchema['id'];
  products: State['products'];
  linkedEntitlements: State['linkedEntitlements'];
}) => {
  if (products[parentEntitlementId]?.nextBillAnchorDate) {
    return products[parentEntitlementId].nextBillAnchorDate;
  }

  /** Below getIdsOfLinkedProductsAndApps is used to fetch all the linked products and apps */
  const { productIds, appIds } = getIdsOfLinkedProductsAndApps({
    productId: parentEntitlementId,
    productsObj: products,
    appsObj: linkedEntitlements,
  });

  /** In case of Family product first check timestamp in sibling product if any sibling exists */
  if (products[parentEntitlementId]?.containerId && productIds.length > 0) {
    const linkedProductTimestamps = productIds
      .filter((productId) => products[productId].nextBillAnchorDate)
      .map((productId) => products[productId].nextBillAnchorDate);
    if (linkedProductTimestamps.length > 0) {
      return linkedProductTimestamps[0];
    }
  }

  /** Fetching timestamp from linked app in case app exists */
  if (appIds?.length > 0) {
    const allApps = Object.values(linkedEntitlements).flatMap((apps) => apps);
    const linkedAppTimestamps = allApps
      .filter((app) => appIds.includes(app.id) && app.nextBillAnchorDate)
      .map((app) => app.nextBillAnchorDate);
    if (linkedAppTimestamps.length > 0) {
      return linkedAppTimestamps[0];
    }
  }

  return '';
};
